"use strict";
var __spreadArrays = (this && this.__spreadArrays) || function () {
    for (var s = 0, i = 0, il = arguments.length; i < il; i++) s += arguments[i].length;
    for (var r = Array(s), k = 0, i = 0; i < il; i++)
        for (var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)
            r[k] = a[j];
    return r;
};
Object.defineProperty(exports, "__esModule", { value: true });
var const_1 = require("../const");
exports.mapRawData = function (data) {
    var sum = data.reduce(function (accumulator, value) { return accumulator + value; }, 0);
    return data.reduce(function (accumulator, value, index) {
        var angle = value / sum * 2 * Math.PI;
        var previousValue = accumulator[index - 1];
        return __spreadArrays(accumulator, [
            {
                color: const_1.DEFAULT_COLORS[index % const_1.DEFAULT_COLORS.length],
                endAngle: previousValue ? previousValue.endAngle + angle : angle,
                index: index,
                moved: false,
                percentageValue: value / sum,
                startAngle: previousValue ? previousValue.endAngle : 0,
                value: value,
            },
        ]);
    }, []);
};
